import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';

const AddMappingButton = ({ code }) => {
    const dispatch = useDispatch();

    const addMapping = () => {
        dispatch(actions.daylight.setActionTargetCode(code));
        dispatch(actions.daylight.setAddMappingModalOpen(true));
    };

    return (
        <FontAwesomeIcon
            className="ml-2 add-mapping pop-hoverable mr-2"
            onClick={addMapping}
            icon={faPlusSquare}
            title="Add Mapping"
            size="lg"
        />
    );
};

export default AddMappingButton;
